let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gQN5G")).then(() => parcelRequire('i4k66'));